import React from 'react';
import { SEO } from '../components/seo/SEO';
import { MarkdownPage } from '../components/content/MarkdownPage';
import content from '../content/insights/data-quality-ai.md?raw';

export const InsightsDataQuality: React.FC = () => {
  return (
    <>
      <SEO
        title="Data Quality & Integration for AI"
        description="Contracts, validation, observability, and readiness patterns for AI data pipelines."
        canonical="/insights/data-quality-ai"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: 'Data Quality & Integration for AI',
          description:
            'Contracts, validation, observability, and readiness patterns for AI data pipelines.',
          author: { '@type': 'Organization', name: 'Integrova AI GmbH' },
          publisher: {
            '@type': 'Organization',
            name: 'Integrova AI GmbH',
            logo: { '@type': 'ImageObject', url: 'https://integrovaai.de/og-default.png' },
          },
          mainEntityOfPage: { '@type': 'WebPage', '@id': 'https://integrovaai.de/insights/data-quality-ai' },
          datePublished: '2025-12-20',
          dateModified: '2025-12-20',
        }}
      />
      <MarkdownPage
        title="Data Quality & Integration for AI"
        eyebrow="Insights"
        content={content}
      />
    </>
  );
};

export default InsightsDataQuality;
